module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("To FLORA ALLEN DRURY – 1894-1973")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("Here lies a heart,")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("Dead not half a year;")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("I shan’t defile her grave")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("With half a tear.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("I would, instead, recall")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("The many times she paced")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("This ground to meet")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("Her love’s embrace …")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("Remember her smiles,")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("Easily won …")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("Remember how her hair")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("Shone in the sun …")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("Remember how great beauty")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("Brought her tears …")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("Remember that she loved me")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_vm._v("Many years.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d94568","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0005.vue
// module id = 72
// module chunks = 0